/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

module.exports = {
  breadCrumb: [],
  alertInfo: "",
  btnArr: []
}



// WEBPACK FOOTER //
// ./src/common/vuex/state/common.js